import { connect } from 'react-redux';
import { actions as modalsActions } from '~/modals';
import { actions as queueActions } from '~/queue';
import { actions as draftActions } from '~/drafts';
import { campaignEdit, campaignTab, campaignCreate } from '~/routes';
import { getURL } from '~/server/formatters';
import { CampaignTab } from '~/campaign/types';
import { movePostToDrafts } from '~/post/thunks';
import { actions } from './reducer';
import ViewCampaign from './components/ViewCampaign';

export default connect(
  (state, ownProps) => {
    const { campaignPosts } = state.campaign;
    return {
      campaign: state.campaign.campaign,
      campaignPosts: campaignPosts || [],
      showComposer: state.campaign.showComposer,
      editMode: state.campaign.editMode,
      editingPostId: state.campaign.editingPostId,
      hideAnalyzeReport: !state.organizations.selected?.canSeeCampaignsReport,
      showCampaignActions: state.organizations.selected?.canModifyCampaigns,
      isLoading: state.campaign.isLoading,
      hideSkeletonHeader: state.campaign.hideSkeletonHeader,
      campaignId: ownProps.match?.params?.id || state.campaign?.campaignId,
      page: state.campaign.page,
      hasCampaignsFlip: state.organizations.selected?.hasCampaignsFeature,
      hasAnalyticsOnPosts: state.organizations.selected?.hasAnalyticsOnPosts,
      hasTwitterImpressions:
        state.organizations.selected?.hasTwitterImpressions,
    };
  },

  (dispatch, ownProps) => ({
    actions: {
      onComposerCreateSuccess: () => {
        dispatch(actions.handleCloseComposer());
      },
      onConfirmDismissComposer: () => {
        dispatch(actions.handleCloseComposer());
      },
      onCreateCampaignClick: () => {
        dispatch(campaignCreate.goTo());
      },
      onCreatePostClick: (campaignId) => {
        dispatch(actions.handleOpenComposer({ campaignId, editMode: false }));
      },
      onDeleteCampaignClick: (campaign) => {
        dispatch(modalsActions.showDeleteCampaignModal(campaign));
      },
      goToAnalyzeReport: (campaign) => {
        dispatch(actions.goToAnalyzeReport(campaign));
      },
      onEditCampaignClick: (campaignId) => {
        if (campaignId) {
          dispatch(
            campaignEdit.goTo({
              campaignId,
              from: ownProps.history.location.pathname,
            })
          );
        }
      },
      fetchCampaign: ({ campaignId, past, status }) => {
        dispatch(
          actions.fetchCampaign({ campaignId, past, status, fullItems: true })
        );
      },
    },
    postActions: {
      onSetRemindersClick: ({ post }) => {
        const nextUrl = campaignTab.getRoute({
          campaignId: post.campaignDetails.id,
          tab: CampaignTab.Scheduled,
        });
        const reminderUrl = getURL.getRemindersURL({
          profileId: post.profileId,
          nextUrl,
        });
        window.location.assign(reminderUrl);
      },
      onShareAgainClick: ({ post }) => {
        dispatch(
          actions.handleShareAgainClick({
            post,
            profileId: post.profileId,
          })
        );
      },
      onEditClick: ({ post }) => {
        dispatch(
          actions.handleOpenComposer({
            post,
            profileId: post.profileId,
            editMode: true,
          })
        );
      },
      onDeleteConfirmClick: ({ post }) => {
        if (!post.isDraft) {
          dispatch(
            queueActions.handleDeleteConfirmClick({
              post,
              profileId: post.profileId,
            })
          );
        } else {
          dispatch(
            draftActions.handleDeleteConfirmClick({
              draft: post,
              profileId: post.profileId,
            })
          );
        }
        dispatch(
          actions.handleDeleteConfirmClick({
            post,
          })
        );
      },
      onRescheduleClick: ({ draft }) => {
        dispatch(
          actions.handleOpenComposer({
            post: draft,
            profileId: draft.profileId,
            editMode: true,
          })
        );
      },
      onApproveClick: ({ draft }) => {
        dispatch(
          draftActions.handleApproveClick({
            draft,
            profileId: ownProps.profileId,
          })
        );
      },
      onRequestApprovalClick: ({ draft }) => {
        dispatch(
          draftActions.handleRequestApprovalClick({
            draft,
            profileId: ownProps.profileId,
            needsApproval: true,
          })
        );
      },
      onRevertApprovalClick: ({ draft }) => {
        dispatch(
          draftActions.handleRequestApprovalClick({
            draft,
            profileId: ownProps.profileId,
            needsApproval: false,
          })
        );
      },
      onMovePostToDraftsClick: ({ post }) => {
        dispatch(movePostToDrafts({ postId: post.id }));
      },
      onRequeueClick: ({ post }) => {
        dispatch(
          queueActions.handleRequeue({
            post,
            profileId: post.profileId,
          })
        );
      },
      onShareNowClick: ({ post }) => {
        dispatch(
          queueActions.handleShareNowClick({
            post,
            profileId: post.profileId,
          })
        );
        dispatch(
          actions.handleShareNowClick({
            post,
          })
        );
      },
    },
  })
)(ViewCampaign);

export { default as reducer, actions, actionTypes } from './reducer';
export { default as middleware } from './middleware';
